import "./column-components.c66242f5.js";
import "./column-components.a60d0bb9.js";
import "./column-components.c077d708.js";
import "./column-components.f57c6dd5.js";
import "./column-components.b2a20dc1.js";
import {useMemo as $j0dCO$useMemo, useRef as $j0dCO$useRef, useEffect as $j0dCO$useEffect, useContext as $j0dCO$useContext} from "react";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $4bJ9d = parcelRequire("4bJ9d");

var $dl5CL = parcelRequire("dl5CL");

var $jMtLz = parcelRequire("jMtLz");

var $7LSYr = parcelRequire("7LSYr");

var $aVUB5 = parcelRequire("aVUB5");
function $069376c47959acd8$export$53e4fd4e0e3d986(props) {
    let { onClickNote: onClickNote, ...rest } = props;
    const { notes: notes, nodes: nodeIndex, updateHeight: updateHeight, noteComponent: noteComponent, scale: scale } = (0, $dl5CL.useNoteLayout)();
    const { pixelHeight: columnHeight } = (0, $aVUB5.useColumn)();
    const notesInfo = (0, $j0dCO$useMemo)(()=>{
        let notes1 = notes.map((note)=>{
            const node = nodeIndex[note.id];
            const pixelHeight = node?.width ?? 10;
            const pixelOffset = node?.currentPos ?? scale(note.top_height);
            return {
                note: note,
                node: node,
                pixelOffset: pixelOffset,
                pixelHeight: pixelHeight,
                spacing: {
                    above: pixelOffset - pixelHeight,
                    below: columnHeight - pixelOffset
                }
            };
        });
        // Adjust spacing to account for nearby nodes
        for(let i = 0; i < notes1.length; i++){
            const { spacing: spacing, pixelOffset: pixelOffset } = notes1[i];
            if (i > 0) {
                const prevNote = notes1[i - 1];
                // Get distance from the previous note's bottom
                // to the current note's top
                spacing.above = pixelOffset - prevNote.pixelOffset - prevNote.pixelHeight;
                prevNote.spacing.below = spacing.above;
            }
        }
        return notes1;
    }, [
        notes,
        nodeIndex,
        scale
    ]);
    return (0, $4bJ9d.default)("g.notes-list", notesInfo.map(({ note: note, pixelOffset: pixelOffset, pixelHeight: pixelHeight, spacing: spacing })=>{
        // If the note has a bad pixelOffset, skip it
        if (pixelOffset == null || pixelHeight == null) return null;
        return (0, $4bJ9d.default)($069376c47959acd8$var$Note, {
            key: note.id,
            note: note,
            pixelOffset: pixelOffset,
            pixelHeight: pixelHeight,
            updateHeight: updateHeight,
            onClick: onClickNote,
            noteBodyComponent: noteComponent,
            spacing: spacing,
            ...rest
        });
    }));
}
function $069376c47959acd8$var$Note(props) {
    const { note: note, pixelOffset: pixelOffset, pixelHeight: pixelHeight, updateHeight: updateHeight, deltaConnectorAttachment: deltaConnectorAttachment, noteBodyComponent: noteBodyComponent, spacing: spacing, onClick: onClick } = props;
    const ref = (0, $j0dCO$useRef)(null);
    (0, $j0dCO$useEffect)(()=>{
        if (ref.current) {
            const newHeight = ref.current.offsetHeight;
            if (newHeight !== pixelHeight) updateHeight(note.id, newHeight);
        }
    }, [
        note,
        pixelHeight,
        updateHeight
    ]);
    const offsetY = pixelOffset;
    const noteHeight = pixelHeight;
    const { setEditingNote: setEditingNote, editingNote: editingNote } = (0, $j0dCO$useContext)((0, $jMtLz.NoteEditorContext));
    const onClick_ = onClick ?? setEditingNote;
    const _onClickHandler = (0, $j0dCO$useMemo)(()=>{
        if (!onClick_) return undefined;
        return (evt)=>{
            onClick_(note);
        };
    }, [
        onClick_
    ]);
    if (editingNote === note) return null;
    return (0, $4bJ9d.default)("g.note", [
        (0, $4bJ9d.default)((0, $7LSYr.NoteConnector), {
            note: note,
            deltaConnectorAttachment: deltaConnectorAttachment
        }),
        (0, $4bJ9d.default)((0, $7LSYr.NotePositioner), {
            offsetY: offsetY,
            noteHeight: noteHeight,
            ref: ref,
            onClick: _onClickHandler
        }, (0, $4bJ9d.default)(noteBodyComponent, {
            note: note,
            spacing: spacing
        }))
    ]);
}


export {$069376c47959acd8$export$53e4fd4e0e3d986 as NotesList, $1f6f8b01a1fba95b$export$ae56508882661985 as NotePositioner, $1f6f8b01a1fba95b$export$a05ee380fe56e446 as NoteConnector};
//# sourceMappingURL=column-components.5cffef96.js.map
